import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import { withStyles } from '@mui/styles';
import AccountMenuHeader from './AccountMenuHeader';
import AccountMenuNavigation from './AccountMenuNavigation';
import AccountMenuActions from './AccountMenuActions';
import AccountMenuLogoutAction from './AccountMenuLogoutAction';

const StyledMenu = withStyles((theme) => ({
	paper: {
		minWidth: theme.spacing(44),
		width: 'max-content',
		maxWidth: '90vw',
		marginTop: theme.spacing(5),
	},
	list: {
		paddingTop: `${theme.spacing(0)} !important`,
	},
}))((props) => <Menu {...props} />);

function AccountMenuPanel({
	isMobile,
	anchorEl = null,
	isOpen,
	theme,
	t,
	currentUser = undefined,
	canSendFeedback = true,
	isImpersonating,
	onClose,
	onNavigateMyAccount,
	onNavigateContactUs,
	onNavigateImpersonateCustomers,
	onEndImpersonation,
	onLogout,
}) {
	const menuOrigin = {
		vertical: 'top',
		horizontal: 'right',
	};

	const styles = {
		mobileMenu: {
			marginTop: '-1.5rem',
			marginLeft: theme.spacing(2.5),
		},
	};

	return (
		<StyledMenu
			aria-label="text"
			role="menuitem"
			tabIndex={0}
			anchorEl={anchorEl}
			anchorOrigin={menuOrigin}
			id={isMobile ? 'account-menu-mobile' : 'account-menu-desktop'}
			keepMounted
			transformOrigin={menuOrigin}
			sx={isMobile ? styles.mobileMenu : undefined}
			open={isOpen}
			onClose={onClose}
		>
			<AccountMenuHeader
				isMobile={isMobile}
				isImpersonating={isImpersonating}
				theme={theme}
				t={t}
				currentUser={currentUser}
				onEndImpersonation={onEndImpersonation}
				onCloseMenu={onClose}
			/>
			<AccountMenuNavigation
				isMobile={isMobile}
				isImpersonating={isImpersonating}
				canSendFeedback={canSendFeedback}
				theme={theme}
				t={t}
				currentUser={currentUser}
				onNavigateMyAccount={onNavigateMyAccount}
				onNavigateContactUs={onNavigateContactUs}
				onNavigateImpersonateCustomers={onNavigateImpersonateCustomers}
			/>
			<Divider />
			<AccountMenuActions t={t} />
			<Divider />
			<AccountMenuLogoutAction t={t} onLogout={onLogout} />
		</StyledMenu>
	);
}

AccountMenuPanel.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	anchorEl: PropTypes.object,
	isOpen: PropTypes.bool.isRequired,
	theme: PropTypes.object.isRequired,
	t: PropTypes.func.isRequired,
	currentUser: PropTypes.object,
	canSendFeedback: PropTypes.bool,
	isImpersonating: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onNavigateMyAccount: PropTypes.func.isRequired,
	onNavigateContactUs: PropTypes.func.isRequired,
	onNavigateImpersonateCustomers: PropTypes.func.isRequired,
	onEndImpersonation: PropTypes.func.isRequired,
	onLogout: PropTypes.func.isRequired,
};

export default AccountMenuPanel;
